export const formatDate = date => new Date(date).toLocaleDateString('fr-FR')

export const formatDateTime = iso => {
  if (!iso)
    return '-'
  const date = new Date(iso)
  const day = date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
  const time = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
  return `${day}, ${time}`
}

// Local-timezone ISO date (YYYY-MM-DD). Use for API query params, never UTC
// — otherwise a Paris-midnight filter can drift by one day.
export const formatDateParam = date => {
  if (!date)
    return null
  const localDate = new Date(date)
  const year = localDate.getFullYear()
  const month = String(localDate.getMonth() + 1).padStart(2, '0')
  const day = String(localDate.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const todayIso = () => formatDateParam(new Date())

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/u

export const isValidIsoDate = value => {
  if (typeof value !== 'string' || !ISO_DATE_PATTERN.test(value))
    return false
  const date = new Date(value)
  return !Number.isNaN(date.getTime()) && formatDateParam(date) === value
}
